import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";
import ToastNotification from "Components/UI/ToastNotification";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import ClaimForm from "Components/Form/ClaimForm";
import { FormProvider, useForm } from "react-hook-form";
import { format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";
import { addClaimValidation } from "core/Operations/ValidationSchema/claimValidationSchema";
import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import { useInsertLocationMutation } from "AppQuries/master/Location/location";
import { locationValidation } from "core/Operations/ValidationSchema/MasterValidationSchema";
import LocationForm from "Components/Form/LocationForm";
import { BackIcon } from "Components/UI/Icon/Icons";
import { toast } from "core/Operations/toast";
import { getCurrentFormattedDate } from "core/Operations/dateFormat";
const AddLocation = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addLocation,
    isPending,
    isError,
    error,
  } = useInsertLocationMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      locationCode: "",
      locationName: "",
      address1: "",
      address2: "",
      address3: "",
      country: "",
      zipCode: "",
      createUser: userData.userName,
      createDate: getCurrentFormattedDate(),
      modifyUser: userData.userName,
      modifyDate: getCurrentFormattedDate(),
      isActive: true,
    },
    resolver: yupResolver(locationValidation),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;
  const onSubmit = (payload) => {
    addLocation(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Location Added Successfully.");
          navigate(`${all_routes.master}${all_routes.location}`);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Location</h4>
                    <h6>Add your new location </h6>
                  </div>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save Location</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}${all_routes.location}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Location</h4>
                    </div>
                    <div className="card-body">
                      <LocationForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddLocation;
